import { getAllMenuItems } from "@/api/menu";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

type UseMenuItemsOptions = {
  page?: number;
  size?: number;
  search?: string;
  enabled?: boolean;
};

export const useMenuItems = (
  roleId?: number,
  viewMode?: "table" | "tree",
  options: UseMenuItemsOptions = {}
) => {
  const [searchParams] = useSearchParams();

  const pageValue = options.page ?? (Number(searchParams.get("page")) || 1);
  const searchValue = options.search ?? (searchParams.get("search") || "");

  const isTree = viewMode === "tree";

  const sizeValue = options.size ?? (isTree ? 0 : (Number(searchParams.get("size")) || 5));

  const safePage = isTree ? 1 : pageValue;
  const enabled = options.enabled ?? true;

  return useQuery({
    queryKey: ["menu-items", viewMode, roleId, safePage, sizeValue, searchValue],

    queryFn: () =>
      getAllMenuItems({
        page: safePage,
        size: sizeValue,
        search: searchValue,
        roleId
      }),

    refetchOnMount: false,

    staleTime: 1000 * 30,
    enabled
  });
};